/*
 * @Description:
 * @Date: 2022-01-18 10:48:04
 */
import { userEnterpriseTypeMapping } from '../mapping';

export const userEnterpriseType = {
  width: 180,
  id: 'userEnterpriseType',
  key: 'userEnterpriseType',
  tip: '项目参与人类型',
  label: '项目参与人类型',
  required: false,
  slot: 'select',
  clearable: true,
  options: [
    userEnterpriseTypeMapping[1],
    userEnterpriseTypeMapping[2],
    userEnterpriseTypeMapping[3]
  ]
};
export const individualEnterpriseName = {
  width: 180,
  tip: '个体名称',
  label: '个体名称',
  key: 'individualEnterpriseName',
  id: 'individualEnterpriseName',
  slot: 'input'
};
export const activityName = {
  width: 180,
  tip: '请输入活动名称',
  label: '活动',
  key: 'activityName',
  id: 'activityName',
  slot: 'input'
};
